// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RestrictedFilespaceListItem-module__Container__oNJC0 {
    border-radius: var(--ds-border-radius-sm);
    /* stylelint-disable-next-line selector-max-specificity -- need to style focus-visible only */
    &:focus-visible {
        border-radius: var(--ds-border-radius-sm);
        outline-offset: calc(-1 * var(--ds-05x));
    }

    &:hover {
        background-color: var(--ds-interaction-hover);
    }
}

.RestrictedFilespaceListItem-module__Icon__Bn6VN {
    color: var(--ds-font-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `RestrictedFilespaceListItem-module__Container__oNJC0`,
	"Icon": `RestrictedFilespaceListItem-module__Icon__Bn6VN`
};
export default ___CSS_LOADER_EXPORT___;
